import React from 'react'

const incident_status_legend = () => {
  const mapOverlayStyle = {
    position: "absolute", /* Position relative to #map-container */
    bottom: "30px",
    right:"30px",
    width: "260px",
    backgroundColor: "white", /* Semi-transparent white */
    border: "1px solid #ccc",
    padding: "10px",
    zIndex: "10", /* Ensure it's above the map */
    borderRadius: "10px"
  }
  
  const colorLegend = (color) => {
    return <div style={{width:"10px", height:"10px", borderRadius:"50%", backgroundColor:color, marginRight:'5px'}}/>
  }

  return (
    <div style={mapOverlayStyle}>
      <div className="d-flex align-items-center">
        {colorLegend("#FD9A8D")}
        <p>New</p>
      </div>
      <div className="d-flex align-items-center">
        {colorLegend("#FFAF7E")}
        <p>Assigned / Acknowledged</p>
      </div>
      <div className="d-flex align-items-center">
        {colorLegend("#FFCF74")}
        <p>In Transit</p>
      </div>
      <div className="d-flex align-items-center">
        {colorLegend("#6BC2D1")}
        <p>In Progress</p>
      </div>
      <div className="d-flex align-items-center">
        {colorLegend("#ABD19E")}
        <p>Closed</p>
      </div>
      <div className="d-flex align-items-center">
        {colorLegend("#BB84E9")}
        <p>Proactive Outreach</p>
      </div>
    </div>
  )
}

export default incident_status_legend
